"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emojis = void 0;
exports.emojis = [
    {
        name: 'smile',
        categories: ['Smileys and emotions'],
        tags: [':smile:'],
        durationInSeconds: 2.3333333333333335,
        codepoint: '1f600',
    },
    {
        name: 'smile-with-big-eyes',
        categories: ['Smileys and emotions'],
        tags: [':smile-with-big-eyes:'],
        durationInSeconds: 2.6666666666666665,
        codepoint: '1f603',
    },
    {
        name: 'grin',
        categories: ['Smileys and emotions'],
        tags: [':grin:'],
        durationInSeconds: 2.3333333333333335,
        codepoint: '1f604',
    },
    {
        name: 'grinning',
        categories: ['Smileys and emotions'],
        tags: [':grinning:'],
        durationInSeconds: 2.716666666666667,
        codepoint: '1f601',
    },
    {
        name: 'laughing',
        categories: ['Smileys and emotions'],
        tags: [':laughing:'],
        durationInSeconds: 3.0833333333333335,
        codepoint: '1f606',
    },
    {
        name: 'grin-sweat',
        categories: ['Smileys and emotions'],
        tags: [':grin-sweat:'],
        durationInSeconds: 2,
        codepoint: '1f605',
    },
    {
        name: 'joy',
        categories: ['Smileys and emotions'],
        tags: [':joy:'],
        durationInSeconds: 1.9666666666666666,
        codepoint: '1f602',
    },
    {
        name: 'rofl',
        categories: ['Smileys and emotions'],
        tags: [':rofl:'],
        durationInSeconds: 1,
        codepoint: '1f923',
    },
    {
        name: 'loudly-crying',
        categories: ['Smileys and emotions'],
        tags: [':loudly-crying:'],
        durationInSeconds: 2,
        codepoint: '1f62d',
    },
    {
        name: 'wink',
        categories: ['Smileys and emotions'],
        tags: [':wink:'],
        durationInSeconds: 2.5,
        codepoint: '1f609',
    },
    {
        name: 'kissing',
        categories: ['Smileys and emotions'],
        tags: [':kissing:'],
        durationInSeconds: 2.8666666666666667,
        codepoint: '1f617',
    },
    {
        name: 'kissing-smiling-eyes',
        categories: ['Smileys and emotions'],
        tags: [':kissing-smiling-eyes:'],
        durationInSeconds: 3,
        codepoint: '1f619',
    },
    {
        name: 'kissing-closed-eyes',
        categories: ['Smileys and emotions'],
        tags: [':kissing-closed-eyes:'],
        durationInSeconds: 1.4666666666666666,
        codepoint: '1f61a',
    },
    {
        name: 'kissing-heart',
        categories: ['Smileys and emotions'],
        tags: [':kissing-heart:'],
        durationInSeconds: 1.75,
        codepoint: '1f618',
    },
    {
        name: 'heart-face',
        categories: ['Smileys and emotions'],
        tags: [':heart-face:', ':3-hearts:'],
        durationInSeconds: 1.6333333333333333,
        codepoint: '1f970',
    },
    {
        name: 'heart-eyes',
        categories: ['Smileys and emotions'],
        tags: [':heart-eyes:'],
        durationInSeconds: 1.7166666666666666,
        codepoint: '1f60d',
    },
    {
        name: 'star-struck',
        categories: ['Smileys and emotions'],
        tags: [':star-struck:'],
        durationInSeconds: 2,
        codepoint: '1f929',
    },
    {
        name: 'partying-face',
        categories: ['Smileys and emotions'],
        tags: [':partying-face:'],
        durationInSeconds: 1.8,
        codepoint: '1f973',
    },
    {
        name: 'melting',
        categories: ['Smileys and emotions'],
        tags: [':melting:'],
        durationInSeconds: 3.25,
        codepoint: '1fae0',
    },
    {
        name: 'upside-down-face',
        categories: ['Smileys and emotions'],
        tags: [':upside-down-face:'],
        durationInSeconds: 1.75,
        codepoint: '1f643',
    },
    {
        name: 'slightly-happy',
        categories: ['Smileys and emotions'],
        tags: [':slightly-happy:'],
        durationInSeconds: 3.3333333333333335,
        codepoint: '1f642',
    },
    {
        name: 'happy-cry',
        categories: ['Smileys and emotions'],
        tags: [':happy-cry:'],
        durationInSeconds: 3,
        codepoint: '1f972',
    },
    {
        name: 'holding-back-tears',
        categories: ['Smileys and emotions'],
        tags: [':holding-back-tears:'],
        durationInSeconds: 3.8666666666666667,
        codepoint: '1f979',
    },
    {
        name: 'blush',
        categories: ['Smileys and emotions'],
        tags: [':blush:'],
        durationInSeconds: 2.65,
        codepoint: '1f60a',
    },
    {
        name: 'warm-smile',
        categories: ['Smileys and emotions'],
        tags: [':warm-smile:'],
        durationInSeconds: 2.2,
        codepoint: '263a_fe0f',
    },
    {
        name: 'relieved',
        categories: ['Smileys and emotions'],
        tags: [':relieved:'],
        durationInSeconds: 2.9,
        codepoint: '1f60c',
    },
    {
        name: 'smirk',
        categories: ['Smileys and emotions'],
        tags: [':smirk:'],
        durationInSeconds: 2,
        codepoint: '1f60f',
    },
    {
        name: 'drool',
        categories: ['Smileys and emotions'],
        tags: [':drool:'],
        durationInSeconds: 2.1666666666666665,
        codepoint: '1f924',
    },
    {
        name: 'yum',
        categories: ['Smileys and emotions'],
        tags: [':yum:'],
        durationInSeconds: 1.4166666666666667,
        codepoint: '1f60b',
    },
    {
        name: 'stuck-out-tongue',
        categories: ['Smileys and emotions'],
        tags: [':stuck-out-tongue:'],
        durationInSeconds: 2,
        codepoint: '1f61b',
    },
    {
        name: 'squinting-tongue',
        categories: ['Smileys and emotions'],
        tags: [':squinting-tongue:'],
        durationInSeconds: 1.6666666666666667,
        codepoint: '1f61d',
    },
    {
        name: 'winky-tongue',
        categories: ['Smileys and emotions'],
        tags: [':winky-tongue:'],
        durationInSeconds: 1.5833333333333333,
        codepoint: '1f61c',
    },
    {
        name: 'zany-face',
        categories: ['Smileys and emotions'],
        tags: [':zany-face:'],
        durationInSeconds: 1.8333333333333333,
        codepoint: '1f92a',
    },
    {
        name: 'woozy',
        categories: ['Smileys and emotions'],
        tags: [':woozy:'],
        durationInSeconds: 1.8,
        codepoint: '1f974',
    },
    {
        name: 'pensive',
        categories: ['Smileys and emotions'],
        tags: [':pensive:'],
        durationInSeconds: 2.6333333333333333,
        codepoint: '1f614',
    },
    {
        name: 'pleading',
        categories: ['Smileys and emotions'],
        tags: [':pleading:'],
        durationInSeconds: 3.433333333333333,
        codepoint: '1f97a',
    },
    {
        name: 'grimacing',
        categories: ['Smileys and emotions'],
        tags: [':grimacing:'],
        durationInSeconds: 2.95,
        codepoint: '1f62c',
    },
    {
        name: 'expressionless',
        categories: ['Smileys and emotions'],
        tags: [':expressionless:'],
        durationInSeconds: 2.5,
        codepoint: '1f611',
    },
    {
        name: 'neutral-face',
        categories: ['Smileys and emotions'],
        tags: [':neutral-face:'],
        durationInSeconds: 3.3333333333333335,
        codepoint: '1f610',
    },
    {
        name: 'mouth-none',
        categories: ['Smileys and emotions'],
        tags: [':mouth-none:'],
        durationInSeconds: 3.3333333333333335,
        codepoint: '1f636',
    },
    {
        name: 'face-in-clouds',
        categories: ['Smileys and emotions'],
        tags: [':face-in-clouds:', ':lost:'],
        durationInSeconds: 2.8666666666666667,
        codepoint: '1f636_200d_1f32b_fe0f',
    },
    {
        name: 'dotted-line-face',
        categories: ['Smileys and emotions'],
        tags: [':dotted-line-face:', ':invisible:'],
        durationInSeconds: 3.6,
        codepoint: '1fae5',
    },
    {
        name: 'zipper-face',
        categories: ['Smileys and emotions'],
        tags: [':zipper-face:'],
        durationInSeconds: 3.7,
        codepoint: '1f910',
    },
    {
        name: 'salute',
        categories: ['Smileys and emotions'],
        tags: [':salute:'],
        durationInSeconds: 2,
        codepoint: '1fae1',
    },
    {
        name: 'thinking-face',
        categories: ['Smileys and emotions'],
        tags: [':thinking-face:'],
        durationInSeconds: 2,
        codepoint: '1f914',
    },
    {
        name: 'shushing-face',
        categories: ['Smileys and emotions'],
        tags: [':shushing-face:'],
        durationInSeconds: 2,
        codepoint: '1f92b',
    },
    {
        name: 'hand-over-mouth',
        categories: ['Smileys and emotions'],
        tags: [':hand-over-mouth:'],
        durationInSeconds: 1.0833333333333333,
        codepoint: '1fae2',
    },
    {
        name: 'smiling-eyes-with-hand-over-mouth',
        categories: ['Smileys and emotions'],
        tags: [':smiling-eyes-with-hand-over-mouth:', ':chuckling:'],
        durationInSeconds: 1.8,
        codepoint: '1f92d',
    },
    {
        name: 'yawn',
        categories: ['Smileys and emotions'],
        tags: [':yawn:'],
        durationInSeconds: 2.35,
        codepoint: '1f971',
    },
    {
        name: 'hug-face',
        categories: ['Smileys and emotions'],
        tags: [':hug-face:'],
        durationInSeconds: 2,
        codepoint: '1f917',
    },
    {
        name: 'peeking',
        categories: ['Smileys and emotions'],
        tags: [':peeking:'],
        durationInSeconds: 3.85,
        codepoint: '1fae3',
    },
    {
        name: 'screaming',
        categories: ['Smileys and emotions'],
        tags: [':screaming:'],
        durationInSeconds: 1.7,
        codepoint: '1f631',
    },
    {
        name: 'raised-eyebrow',
        categories: ['Smileys and emotions'],
        tags: [':raised-eyebrow:'],
        durationInSeconds: 1.4333333333333333,
        codepoint: '1f928',
    },
    {
        name: 'monocle',
        categories: ['Smileys and emotions'],
        tags: [':monocle:'],
        durationInSeconds: 3.4,
        codepoint: '1f9d0',
    },
    {
        name: 'unamused',
        categories: ['Smileys and emotions'],
        tags: [':unamused:'],
        durationInSeconds: 3.2,
        codepoint: '1f612',
    },
    {
        name: 'rolling-eyes',
        categories: ['Smileys and emotions'],
        tags: [':rolling-eyes:'],
        durationInSeconds: 3.2666666666666666,
        codepoint: '1f644',
    },
    {
        name: 'exhale',
        categories: ['Smileys and emotions'],
        tags: [':exhale:'],
        durationInSeconds: 2.5,
        codepoint: '1f62e_200d_1f4a8',
    },
    {
        name: 'triumph',
        categories: ['Smileys and emotions'],
        tags: [':triumph:'],
        durationInSeconds: 1.5,
        codepoint: '1f624',
    },
    {
        name: 'angry',
        categories: ['Smileys and emotions'],
        tags: [':angry:'],
        durationInSeconds: 2,
        codepoint: '1f620',
    },
    {
        name: 'rage',
        categories: ['Smileys and emotions'],
        tags: [':rage:'],
        durationInSeconds: 3,
        codepoint: '1f621',
    },
    {
        name: 'cursing',
        categories: ['Smileys and emotions'],
        tags: [':cursing:'],
        durationInSeconds: 3,
        codepoint: '1f92c',
    },
    {
        name: 'sad',
        categories: ['Smileys and emotions'],
        tags: [':sad:'],
        durationInSeconds: 3,
        codepoint: '1f61e',
    },
    {
        name: 'sweat',
        categories: ['Smileys and emotions'],
        tags: [':sweat:', ':downcast:'],
        durationInSeconds: 2.25,
        codepoint: '1f613',
    },
    {
        name: 'worried',
        categories: ['Smileys and emotions'],
        tags: [':worried:'],
        durationInSeconds: 2.566666666666667,
        codepoint: '1f61f',
    },
    {
        name: 'concerned',
        categories: ['Smileys and emotions'],
        tags: [':concerned:'],
        durationInSeconds: 4.25,
        codepoint: '1f625',
    },
    {
        name: 'cry',
        categories: ['Smileys and emotions'],
        tags: [':cry:'],
        durationInSeconds: 1.8333333333333333,
        codepoint: '1f622',
    },
    {
        name: 'big-frown',
        categories: ['Smileys and emotions'],
        tags: [':big-frown:'],
        durationInSeconds: 2,
        codepoint: '2639_fe0f',
    },
    {
        name: 'frown',
        categories: ['Smileys and emotions'],
        tags: [':frown:'],
        durationInSeconds: 2.6,
        codepoint: '1f641',
    },
    {
        name: 'diagonal-mouth',
        categories: ['Smileys and emotions'],
        tags: [':diagonal-mouth:'],
        durationInSeconds: 2.2666666666666666,
        codepoint: '1fae4',
    },
    {
        name: 'slightly-frowning',
        categories: ['Smileys and emotions'],
        tags: [':slightly-frowning:'],
        durationInSeconds: 3.316666666666667,
        codepoint: '1f615',
    },
    {
        name: 'anxious-with-sweat',
        categories: ['Smileys and emotions'],
        tags: [':anxious-with-sweat:'],
        durationInSeconds: 2.8,
        codepoint: '1f630',
    },
    {
        name: 'scared',
        categories: ['Smileys and emotions'],
        tags: [':scared:'],
        durationInSeconds: 2.533333333333333,
        codepoint: '1f628',
    },
    {
        name: 'anguished',
        categories: ['Smileys and emotions'],
        tags: [':anguished:'],
        durationInSeconds: 2.3666666666666667,
        codepoint: '1f627',
    },
    {
        name: 'gasp',
        categories: ['Smileys and emotions'],
        tags: [':gasp:'],
        durationInSeconds: 3.1666666666666665,
        codepoint: '1f626',
    },
    {
        name: 'mouth-open',
        categories: ['Smileys and emotions'],
        tags: [':mouth-open:'],
        durationInSeconds: 2.533333333333333,
        codepoint: '1f62e',
    },
    {
        name: 'surprised',
        categories: ['Smileys and emotions'],
        tags: [':surprised:', ':hushed:'],
        durationInSeconds: 1.4666666666666666,
        codepoint: '1f62f',
    },
    {
        name: 'astonished',
        categories: ['Smileys and emotions'],
        tags: [':astonished:'],
        durationInSeconds: 2.566666666666667,
        codepoint: '1f632',
    },
    {
        name: 'flushed',
        categories: ['Smileys and emotions'],
        tags: [':flushed:'],
        durationInSeconds: 2,
        codepoint: '1f633',
    },
    {
        name: 'mind-blown',
        categories: ['Smileys and emotions'],
        tags: [':mind-blown:', ':exploding-head:'],
        durationInSeconds: 2.9,
        codepoint: '1f92f',
    },
    {
        name: 'scrunched-mouth',
        categories: ['Smileys and emotions'],
        tags: [':scrunched-mouth:', ':confounded:', ':zigzag-mouth:'],
        durationInSeconds: 2.033333333333333,
        codepoint: '1f616',
    },
    {
        name: 'scrunched-eyes',
        categories: ['Smileys and emotions'],
        tags: [':scrunched-eyes:', ':persevering:'],
        durationInSeconds: 3.25,
        codepoint: '1f623',
    },
    {
        name: 'weary',
        categories: ['Smileys and emotions'],
        tags: [':weary:'],
        durationInSeconds: 1.7166666666666666,
        codepoint: '1f629',
    },
    {
        name: 'distraught',
        categories: ['Smileys and emotions'],
        tags: [':distraught:'],
        durationInSeconds: 1.7,
        codepoint: '1f62b',
    },
    {
        name: 'x-eyes',
        categories: ['Smileys and emotions'],
        tags: [':x-eyes:'],
        durationInSeconds: 2.8333333333333335,
        codepoint: '1f635',
    },
    {
        name: 'dizzy-face',
        categories: ['Smileys and emotions'],
        tags: [':dizzy-face:'],
        durationInSeconds: 2,
        codepoint: '1f635_200d_1f4ab',
    },
    {
        name: 'shaking-face',
        categories: ['Smileys and emotions'],
        tags: [':shaking-face:'],
        durationInSeconds: 2.1666666666666665,
        codepoint: '1fae8',
    },
    {
        name: 'cold-face',
        categories: ['Smileys and emotions'],
        tags: [':cold-face:'],
        durationInSeconds: 2.033333333333333,
        codepoint: '1f976',
    },
    {
        name: 'hot-face',
        categories: ['Smileys and emotions'],
        tags: [':hot-face:', ':sweat-face:'],
        durationInSeconds: 1.4,
        codepoint: '1f975',
    },
    {
        name: 'sick',
        categories: ['Smileys and emotions'],
        tags: [':sick:', ':nauseated:'],
        durationInSeconds: 2.1333333333333333,
        codepoint: '1f922',
    },
    {
        name: 'vomit',
        categories: ['Smileys and emotions'],
        tags: [':vomit:'],
        durationInSeconds: 4,
        codepoint: '1f92e',
    },
    {
        name: 'sleep',
        categories: ['Smileys and emotions'],
        tags: [':sleep:', ':tired:'],
        durationInSeconds: 2,
        codepoint: '1f634',
    },
    {
        name: 'sleepy',
        categories: ['Smileys and emotions'],
        tags: [':sleepy:'],
        durationInSeconds: 2,
        codepoint: '1f62a',
    },
    {
        name: 'sneeze',
        categories: ['Smileys and emotions'],
        tags: [':sneeze:'],
        durationInSeconds: 2.6,
        codepoint: '1f927',
    },
    {
        name: 'thermometer-face',
        categories: ['Smileys and emotions'],
        tags: [':thermometer-face:'],
        durationInSeconds: 2.7,
        codepoint: '1f912',
    },
    {
        name: 'bandage-face',
        categories: ['Smileys and emotions'],
        tags: [':bandage-face:'],
        durationInSeconds: 3.3333333333333335,
        codepoint: '1f915',
    },
    {
        name: 'mask',
        categories: ['Smileys and emotions'],
        tags: [':mask:'],
        durationInSeconds: 3.2333333333333334,
        codepoint: '1f637',
    },
    {
        name: 'liar',
        categories: ['Smileys and emotions'],
        tags: [':liar:'],
        durationInSeconds: 2.3,
        codepoint: '1f925',
    },
    {
        name: 'halo',
        categories: ['Smileys and emotions'],
        tags: [':halo:', ':innocent:'],
        durationInSeconds: 3.4166666666666665,
        codepoint: '1f607',
    },
    {
        name: 'cowboy',
        categories: ['Smileys and emotions'],
        tags: [':cowboy:'],
        durationInSeconds: 1.6166666666666667,
        codepoint: '1f920',
    },
    {
        name: 'money-face',
        categories: ['Smileys and emotions'],
        tags: [':money-face:'],
        durationInSeconds: 2.3833333333333333,
        codepoint: '1f911',
    },
    {
        name: 'nerd-face',
        categories: ['Smileys and emotions'],
        tags: [':nerd-face:'],
        durationInSeconds: 3,
        codepoint: '1f913',
    },
    {
        name: 'sunglasses-face',
        categories: ['Smileys and emotions'],
        tags: [':sunglasses-face:'],
        durationInSeconds: 2.4166666666666665,
        codepoint: '1f60e',
    },
    {
        name: 'disguise',
        categories: ['Smileys and emotions'],
        tags: [':disguise:'],
        durationInSeconds: 3.7,
        codepoint: '1f978',
    },
    {
        name: 'clown',
        categories: ['Smileys and emotions'],
        tags: [':clown:'],
        durationInSeconds: 2.3,
        codepoint: '1f921',
    },
    {
        name: 'imp-smile',
        categories: ['Smileys and emotions'],
        tags: [':imp-smile:'],
        durationInSeconds: 3.5,
        codepoint: '1f608',
    },
    {
        name: 'imp-frown',
        categories: ['Smileys and emotions'],
        tags: [':imp-frown:'],
        durationInSeconds: 3.5,
        codepoint: '1f47f',
    },
    {
        name: 'ghost',
        categories: ['Smileys and emotions'],
        tags: [':ghost:'],
        durationInSeconds: 2.4,
        codepoint: '1f47b',
    },
    {
        name: 'skull',
        categories: ['Smileys and emotions'],
        tags: [':skull:'],
        durationInSeconds: 5,
        codepoint: '1f480',
    },
    {
        name: 'jack-o-lantern',
        categories: ['Smileys and emotions'],
        tags: [':jack-o-lantern:'],
        durationInSeconds: 3.1666666666666665,
        codepoint: '1f383',
    },
    {
        name: 'poop',
        categories: ['Smileys and emotions'],
        tags: [':poop:'],
        durationInSeconds: 2.4,
        codepoint: '1f4a9',
    },
    {
        name: 'robot',
        categories: ['Smileys and emotions'],
        tags: [':robot:'],
        durationInSeconds: 2.7333333333333334,
        codepoint: '1f916',
    },
    {
        name: 'alien',
        categories: ['Smileys and emotions'],
        tags: [':alien:'],
        durationInSeconds: 3.033333333333333,
        codepoint: '1f47d',
    },
    {
        name: 'sun-with-face',
        categories: ['Smileys and emotions'],
        tags: [':sun-with-face:'],
        durationInSeconds: 1.8666666666666667,
        codepoint: '1f31e',
    },
    {
        name: 'moon-face-first-quarter',
        categories: ['Smileys and emotions'],
        tags: [':moon-face-first-quarter:'],
        durationInSeconds: 4.1,
        codepoint: '1f31b',
    },
    {
        name: 'moon-face-last-quarter',
        categories: ['Smileys and emotions'],
        tags: [':moon-face-last-quarter:'],
        durationInSeconds: 4.233333333333333,
        codepoint: '1f31c',
    },
    {
        name: 'see-no-evil-monkey',
        categories: ['Smileys and emotions'],
        tags: [':see-no-evil-monkey:'],
        durationInSeconds: 2.3833333333333333,
        codepoint: '1f648',
    },
    {
        name: 'hear-no-evil-monkey',
        categories: ['Smileys and emotions'],
        tags: [':hear-no-evil-monkey:'],
        durationInSeconds: 2.3,
        codepoint: '1f649',
    },
    {
        name: 'speak-no-evil-monkey',
        categories: ['Smileys and emotions'],
        tags: [':speak-no-evil-monkey:'],
        durationInSeconds: 2.5,
        codepoint: '1f64a',
    },
    {
        name: 'smiley-cat',
        categories: ['Smileys and emotions'],
        tags: [':smiley-cat:'],
        durationInSeconds: 2.45,
        codepoint: '1f63a',
    },
    {
        name: 'smile-cat',
        categories: ['Smileys and emotions'],
        tags: [':smile-cat:'],
        durationInSeconds: 3.5,
        codepoint: '1f638',
    },
    {
        name: 'joy-cat',
        categories: ['Smileys and emotions'],
        tags: [':joy-cat:'],
        durationInSeconds: 2.933333333333333,
        codepoint: '1f639',
    },
    {
        name: 'heart-eyes-cat',
        categories: ['Smileys and emotions'],
        tags: [':heart-eyes-cat:'],
        durationInSeconds: 2.8,
        codepoint: '1f63b',
    },
    {
        name: 'smirk-cat',
        categories: ['Smileys and emotions'],
        tags: [':smirk-cat:'],
        durationInSeconds: 2.966666666666667,
        codepoint: '1f63c',
    },
    {
        name: 'kissing-cat',
        categories: ['Smileys and emotions'],
        tags: [':kissing-cat:'],
        durationInSeconds: 2.4,
        codepoint: '1f63d',
    },
    {
        name: 'scream-cat',
        categories: ['Smileys and emotions'],
        tags: [':scream-cat:'],
        durationInSeconds: 2.4,
        codepoint: '1f640',
    },
    {
        name: 'crying-cat-face',
        categories: ['Smileys and emotions'],
        tags: [':crying-cat-face:'],
        durationInSeconds: 1.7,
        codepoint: '1f63f',
    },
    {
        name: 'pouting-cat',
        categories: ['Smileys and emotions'],
        tags: [':pouting-cat:'],
        durationInSeconds: 2.2333333333333334,
        codepoint: '1f63e',
    },
    {
        name: 'glowing-star',
        categories: ['Smileys and emotions'],
        tags: [':glowing-star:'],
        durationInSeconds: 1.7833333333333334,
        codepoint: '1f31f',
    },
    {
        name: 'sparkles',
        categories: ['Smileys and emotions'],
        tags: [':sparkles:'],
        durationInSeconds: 2.033333333333333,
        codepoint: '2728',
    },
    {
        name: 'collision',
        categories: ['Smileys and emotions'],
        tags: [':collision:'],
        durationInSeconds: 1.2666666666666666,
        codepoint: '1f4a5',
    },
    {
        name: 'fire',
        categories: ['Smileys and emotions'],
        tags: [':fire:', ':burn:', ':lit:'],
        durationInSeconds: 1.0833333333333333,
        codepoint: '1f525',
    },
    {
        name: '100',
        categories: ['Smileys and emotions'],
        tags: [':100:', ':one-hundred:', ':hundred:', ':points:'],
        durationInSeconds: 2.25,
        codepoint: '1f4af',
    },
    {
        name: 'party-popper',
        categories: ['Smileys and emotions'],
        tags: [':party-popper:'],
        durationInSeconds: 1.5333333333333334,
        codepoint: '1f389',
    },
    {
        name: 'red-heart',
        categories: ['Smileys and emotions'],
        tags: [':red-heart:'],
        durationInSeconds: 1.8333333333333333,
        codepoint: '2764_fe0f',
    },
    {
        name: 'orange-heart',
        categories: ['Smileys and emotions'],
        tags: [':orange-heart:'],
        durationInSeconds: 1.8333333333333333,
        codepoint: '1f9e1',
    },
    {
        name: 'yellow-heart',
        categories: ['Smileys and emotions'],
        tags: [':yellow-heart:'],
        durationInSeconds: 1.8333333333333333,
        codepoint: '1f49b',
    },
    {
        name: 'green-heart',
        categories: ['Smileys and emotions'],
        tags: [':green-heart:'],
        durationInSeconds: 1.8333333333333333,
        codepoint: '1f49a',
    },
    {
        name: 'light-blue-heart',
        categories: ['Smileys and emotions'],
        tags: [':light-blue-heart:'],
        durationInSeconds: 1.8333333333333333,
        codepoint: '1fa75',
    },
    {
        name: 'blue-heart',
        categories: ['Smileys and emotions'],
        tags: [':blue-heart:'],
        durationInSeconds: 1.8333333333333333,
        codepoint: '1f499',
    },
    {
        name: 'purple-heart',
        categories: ['Smileys and emotions'],
        tags: [':purple-heart:'],
        durationInSeconds: 1.8333333333333333,
        codepoint: '1f49c',
    },
    {
        name: 'brown-heart',
        categories: ['Smileys and emotions'],
        tags: [':brown-heart:'],
        durationInSeconds: 1.8333333333333333,
        codepoint: '1f90e',
    },
    {
        name: 'black-heart',
        categories: ['Smileys and emotions'],
        tags: [':black-heart:'],
        durationInSeconds: 1.8333333333333333,
        codepoint: '1f5a4',
    },
    {
        name: 'grey-heart',
        categories: ['Smileys and emotions'],
        tags: [':grey-heart:'],
        durationInSeconds: 1.8333333333333333,
        codepoint: '1fa76',
    },
    {
        name: 'white-heart',
        categories: ['Smileys and emotions'],
        tags: [':white-heart:'],
        durationInSeconds: 1.8333333333333333,
        codepoint: '1f90d',
    },
    {
        name: 'pink-heart',
        categories: ['Smileys and emotions'],
        tags: [':pink-heart:'],
        durationInSeconds: 1.8333333333333333,
        codepoint: '1fa77',
    },
    {
        name: 'cupid',
        categories: ['Smileys and emotions'],
        tags: [':cupid:'],
        durationInSeconds: 2.466666666666667,
        codepoint: '1f498',
    },
    {
        name: 'gift-heart',
        categories: ['Smileys and emotions'],
        tags: [':gift-heart:'],
        durationInSeconds: 4.766666666666667,
        codepoint: '1f49d',
    },
    {
        name: 'sparkling-heart',
        categories: ['Smileys and emotions'],
        tags: [':sparkling-heart:'],
        durationInSeconds: 1,
        codepoint: '1f496',
    },
    {
        name: 'heart-grow',
        categories: ['Smileys and emotions'],
        tags: [':heart-grow:'],
        durationInSeconds: 1.8333333333333333,
        codepoint: '1f497',
    },
    {
        name: 'beating-heart',
        categories: ['Smileys and emotions'],
        tags: [':beating-heart:'],
        durationInSeconds: 0.8,
        codepoint: '1f493',
    },
    {
        name: 'revolving-hearts',
        categories: ['Smileys and emotions'],
        tags: [':revolving-hearts:'],
        durationInSeconds: 1,
        codepoint: '1f49e',
    },
    {
        name: 'two-hearts',
        categories: ['Smileys and emotions'],
        tags: [':two-hearts:'],
        durationInSeconds: 1.2333333333333334,
        codepoint: '1f495',
    },
    {
        name: 'love-letter',
        categories: ['Smileys and emotions'],
        tags: [':love-letter:'],
        durationInSeconds: 3.066666666666667,
        codepoint: '1f48c',
    },
    {
        name: 'heart-box',
        categories: ['Smileys and emotions'],
        tags: [':heart-box:'],
        durationInSeconds: 1.6666666666666667,
        codepoint: '1f49f',
    },
    {
        name: 'heart-exclamation-point',
        categories: ['Smileys and emotions'],
        tags: [':heart-exclamation-point:'],
        durationInSeconds: 2.15,
        codepoint: '2763_fe0f',
    },
    {
        name: 'bandaged-heart',
        categories: ['Smileys and emotions'],
        tags: [':bandaged-heart:'],
        durationInSeconds: 3.1666666666666665,
        codepoint: '2764_fe0f_200d_1fa79',
    },
    {
        name: 'broken-heart',
        categories: ['Smileys and emotions'],
        tags: [':broken-heart:'],
        durationInSeconds: 3.3,
        codepoint: '1f494',
    },
    {
        name: 'fire-heart',
        categories: ['Smileys and emotions'],
        tags: [':fire-heart:'],
        durationInSeconds: 1,
        codepoint: '2764_fe0f_200d_1f525',
    },
    {
        name: 'kiss',
        categories: ['Smileys and emotions'],
        tags: [':kiss:'],
        durationInSeconds: 2,
        codepoint: '1f48b',
    },
    {
        name: 'footprints',
        categories: ['Smileys and emotions'],
        tags: [':footprints:'],
        durationInSeconds: 1.0666666666666667,
        codepoint: '1f463',
    },
    {
        name: 'anatomical-heart',
        categories: ['Smileys and emotions'],
        tags: [':anatomical-heart:'],
        durationInSeconds: 1.3,
        codepoint: '1fac0',
    },
    {
        name: 'blood',
        categories: ['Smileys and emotions'],
        tags: [':blood:'],
        durationInSeconds: 2.1333333333333333,
        codepoint: '1fa78',
    },
    {
        name: 'microbe',
        categories: ['Smileys and emotions'],
        tags: [':microbe:', ':virus:'],
        durationInSeconds: 1.2,
        codepoint: '1f9a0',
    },
    {
        name: 'eyes',
        categories: ['Smileys and emotions'],
        tags: [':eyes:'],
        durationInSeconds: 2,
        codepoint: '1f440',
    },
    {
        name: 'eye',
        categories: ['Smileys and emotions'],
        tags: [':eye:'],
        durationInSeconds: 3.966666666666667,
        codepoint: '1f441_fe0f',
    },
    {
        name: 'biting-lip',
        categories: ['Smileys and emotions'],
        tags: [':biting-lip:'],
        durationInSeconds: 1.6,
        codepoint: '1fae6',
    },
    {
        name: 'leg-mechanical',
        categories: ['Smileys and emotions'],
        tags: [':leg-mechanical:'],
        durationInSeconds: 1.4333333333333333,
        codepoint: '1f9bf',
    },
    {
        name: 'arm-mechanical',
        categories: ['Smileys and emotions'],
        tags: [':arm-mechanical:'],
        durationInSeconds: 2.033333333333333,
        codepoint: '1f9be',
    },
    {
        name: 'muscle',
        categories: ['Smileys and emotions'],
        tags: [':muscle:', ':flex:', ':bicep:', ':strong:'],
        durationInSeconds: 1.4,
        codepoint: '1f4aa',
    },
    {
        name: 'muscle-skin-tone-1',
        categories: ['Smileys and emotions'],
        tags: [':muscle:', ':flex:', ':bicep:', ':strong:'],
        durationInSeconds: 1.4,
        codepoint: '1f4aa_1f3fb',
    },
    {
        name: 'muscle-skin-tone-2',
        categories: ['Smileys and emotions'],
        tags: [':muscle:', ':flex:', ':bicep:', ':strong:'],
        durationInSeconds: 1.4,
        codepoint: '1f4aa_1f3fc',
    },
    {
        name: 'muscle-skin-tone-3',
        categories: ['Smileys and emotions'],
        tags: [':muscle:', ':flex:', ':bicep:', ':strong:'],
        durationInSeconds: 1.4,
        codepoint: '1f4aa_1f3fd',
    },
    {
        name: 'muscle-skin-tone-4',
        categories: ['Smileys and emotions'],
        tags: [':muscle:', ':flex:', ':bicep:', ':strong:'],
        durationInSeconds: 1.4,
        codepoint: '1f4aa_1f3fe',
    },
    {
        name: 'muscle-skin-tone-5',
        categories: ['Smileys and emotions'],
        tags: [':muscle:', ':flex:', ':bicep:', ':strong:'],
        durationInSeconds: 1.4,
        codepoint: '1f4aa_1f3ff',
    },
    {
        name: 'clap',
        categories: ['Smileys and emotions'],
        tags: [':clap:'],
        durationInSeconds: 0.31666666666666665,
        codepoint: '1f44f',
    },
    {
        name: 'clap-skin-tone-1',
        categories: ['Smileys and emotions'],
        tags: [':clap:'],
        durationInSeconds: 0.31666666666666665,
        codepoint: '1f44f_1f3fb',
    },
    {
        name: 'clap-skin-tone-2',
        categories: ['Smileys and emotions'],
        tags: [':clap:'],
        durationInSeconds: 0.31666666666666665,
        codepoint: '1f44f_1f3fc',
    },
    {
        name: 'clap-skin-tone-3',
        categories: ['Smileys and emotions'],
        tags: [':clap:'],
        durationInSeconds: 0.31666666666666665,
        codepoint: '1f44f_1f3fd',
    },
    {
        name: 'clap-skin-tone-4',
        categories: ['Smileys and emotions'],
        tags: [':clap:'],
        durationInSeconds: 0.31666666666666665,
        codepoint: '1f44f_1f3fe',
    },
    {
        name: 'clap-skin-tone-5',
        categories: ['Smileys and emotions'],
        tags: [':clap:'],
        durationInSeconds: 0.31666666666666665,
        codepoint: '1f44f_1f3ff',
    },
    {
        name: 'thumbs-up',
        categories: ['Smileys and emotions'],
        tags: [':thumbs-up:', ':+1:'],
        durationInSeconds: 2.6333333333333333,
        codepoint: '1f44d',
    },
    {
        name: 'thumbs-up-skin-tone-1',
        categories: ['Smileys and emotions'],
        tags: [':thumbs-up:', ':+1:'],
        durationInSeconds: 2.6333333333333333,
        codepoint: '1f44d_1f3fb',
    },
    {
        name: 'thumbs-up-skin-tone-2',
        categories: ['Smileys and emotions'],
        tags: [':thumbs-up:', ':+1:'],
        durationInSeconds: 2.6333333333333333,
        codepoint: '1f44d_1f3fc',
    },
    {
        name: 'thumbs-up-skin-tone-3',
        categories: ['Smileys and emotions'],
        tags: [':thumbs-up:', ':+1:'],
        durationInSeconds: 2.6333333333333333,
        codepoint: '1f44d_1f3fd',
    },
    {
        name: 'thumbs-up-skin-tone-4',
        categories: ['Smileys and emotions'],
        tags: [':thumbs-up:', ':+1:'],
        durationInSeconds: 2.6333333333333333,
        codepoint: '1f44d_1f3fe',
    },
    {
        name: 'thumbs-up-skin-tone-5',
        categories: ['Smileys and emotions'],
        tags: [':thumbs-up:', ':+1:'],
        durationInSeconds: 2.6333333333333333,
        codepoint: '1f44d_1f3ff',
    },
    {
        name: 'thumbs-down',
        categories: ['Smileys and emotions'],
        tags: [':thumbs-down:'],
        durationInSeconds: 1.2,
        codepoint: '1f44e',
    },
    {
        name: 'thumbs-down-skin-tone-1',
        categories: ['Smileys and emotions'],
        tags: [':thumbs-down:'],
        durationInSeconds: 1.2,
        codepoint: '1f44e_1f3fb',
    },
    {
        name: 'thumbs-down-skin-tone-2',
        categories: ['Smileys and emotions'],
        tags: [':thumbs-down:'],
        durationInSeconds: 1.2,
        codepoint: '1f44e_1f3fc',
    },
    {
        name: 'thumbs-down-skin-tone-3',
        categories: ['Smileys and emotions'],
        tags: [':thumbs-down:'],
        durationInSeconds: 1.2,
        codepoint: '1f44e_1f3fd',
    },
    {
        name: 'thumbs-down-skin-tone-4',
        categories: ['Smileys and emotions'],
        tags: [':thumbs-down:'],
        durationInSeconds: 1.2,
        codepoint: '1f44e_1f3fe',
    },
    {
        name: 'thumbs-down-skin-tone-5',
        categories: ['Smileys and emotions'],
        tags: [':thumbs-down:'],
        durationInSeconds: 1.2,
        codepoint: '1f44e_1f3ff',
    },
    {
        name: 'raising-hands',
        categories: ['Smileys and emotions'],
        tags: [':raising-hands:', ':hooray:'],
        durationInSeconds: 2,
        codepoint: '1f64c',
    },
    {
        name: 'raising-hands-skin-tone-1',
        categories: ['Smileys and emotions'],
        tags: [':raising-hands:', ':hooray:'],
        durationInSeconds: 2,
        codepoint: '1f64c_1f3fb',
    },
    {
        name: 'raising-hands-skin-tone-2',
        categories: ['Smileys and emotions'],
        tags: [':raising-hands:', ':hooray:'],
        durationInSeconds: 2,
        codepoint: '1f64c_1f3fc',
    },
    {
        name: 'raising-hands-skin-tone-3',
        categories: ['Smileys and emotions'],
        tags: [':raising-hands:', ':hooray:'],
        durationInSeconds: 2,
        codepoint: '1f64c_1f3fd',
    },
    {
        name: 'raising-hands-skin-tone-4',
        categories: ['Smileys and emotions'],
        tags: [':raising-hands:', ':hooray:'],
        durationInSeconds: 2,
        codepoint: '1f64c_1f3fe',
    },
    {
        name: 'raising-hands-skin-tone-5',
        categories: ['Smileys and emotions'],
        tags: [':raising-hands:', ':hooray:'],
        durationInSeconds: 2,
        codepoint: '1f64c_1f3ff',
    },
    {
        name: 'wave',
        categories: ['Smileys and emotions'],
        tags: [':wave:'],
        durationInSeconds: 0.9666666666666667,
        codepoint: '1f44b',
    },
    {
        name: 'wave-skin-tone-1',
        categories: ['Smileys and emotions'],
        tags: [':wave:'],
        durationInSeconds: 0.9666666666666667,
        codepoint: '1f44b_1f3fb',
    },
    {
        name: 'wave-skin-tone-2',
        categories: ['Smileys and emotions'],
        tags: [':wave:'],
        durationInSeconds: 0.9666666666666667,
        codepoint: '1f44b_1f3fc',
    },
    {
        name: 'wave-skin-tone-3',
        categories: ['Smileys and emotions'],
        tags: [':wave:'],
        durationInSeconds: 0.9666666666666667,
        codepoint: '1f44b_1f3fd',
    },
    {
        name: 'wave-skin-tone-4',
        categories: ['Smileys and emotions'],
        tags: [':wave:'],
        durationInSeconds: 0.9666666666666667,
        codepoint: '1f44b_1f3fe',
    },
    {
        name: 'wave-skin-tone-5',
        categories: ['Smileys and emotions'],
        tags: [':wave:'],
        durationInSeconds: 0.9666666666666667,
        codepoint: '1f44b_1f3ff',
    },
    {
        name: 'victory',
        categories: ['Smileys and emotions'],
        tags: [':victory:', ':v:', ':peace-hand:'],
        durationInSeconds: 1.8,
        codepoint: '270c_fe0f',
    },
    {
        name: 'victory-skin-tone-1',
        categories: ['Smileys and emotions'],
        tags: [':victory:', ':v:', ':peace-hand:'],
        durationInSeconds: 1.8,
        codepoint: '270c_1f3fb',
    },
    {
        name: 'victory-skin-tone-2',
        categories: ['Smileys and emotions'],
        tags: [':victory:', ':v:', ':peace-hand:'],
        durationInSeconds: 1.8,
        codepoint: '270c_1f3fc',
    },
    {
        name: 'victory-skin-tone-3',
        categories: ['Smileys and emotions'],
        tags: [':victory:', ':v:', ':peace-hand:'],
        durationInSeconds: 1.8,
        codepoint: '270c_1f3fd',
    },
    {
        name: 'victory-skin-tone-4',
        categories: ['Smileys and emotions'],
        tags: [':victory:', ':v:', ':peace-hand:'],
        durationInSeconds: 1.8,
        codepoint: '270c_1f3fe',
    },
    {
        name: 'victory-skin-tone-5',
        categories: ['Smileys and emotions'],
        tags: [':victory:', ':v:', ':peace-hand:'],
        durationInSeconds: 1.8,
        codepoint: '270c_1f3ff',
    },
    {
        name: 'crossed-fingers',
        categories: ['Smileys and emotions'],
        tags: [':crossed-fingers:'],
        durationInSeconds: 1.6666666666666667,
        codepoint: '1f91e',
    },
    {
        name: 'crossed-fingers-skin-tone-1',
        categories: ['Smileys and emotions'],
        tags: [':crossed-fingers:'],
        durationInSeconds: 1.6666666666666667,
        codepoint: '1f91e_1f3fb',
    },
    {
        name: 'crossed-fingers-skin-tone-2',
        categories: ['Smileys and emotions'],
        tags: [':crossed-fingers:'],
        durationInSeconds: 1.6666666666666667,
        codepoint: '1f91e_1f3fc',
    },
    {
        name: 'crossed-fingers-skin-tone-3',
        categories: ['Smileys and emotions'],
        tags: [':crossed-fingers:'],
        durationInSeconds: 1.6666666666666667,
        codepoint: '1f91e_1f3fd',
    },
    {
        name: 'crossed-fingers-skin-tone-4',
        categories: ['Smileys and emotions'],
        tags: [':crossed-fingers:'],
        durationInSeconds: 1.6666666666666667,
        codepoint: '1f91e_1f3fe',
    },
    {
        name: 'crossed-fingers-skin-tone-5',
        categories: ['Smileys and emotions'],
        tags: [':crossed-fingers:'],
        durationInSeconds: 1.6666666666666667,
        codepoint: '1f91e_1f3ff',
    },
    {
        name: 'index-finger',
        categories: ['Smileys and emotions'],
        tags: [':index-finger:'],
        durationInSeconds: 1.9666666666666666,
        codepoint: '261d_fe0f',
    },
    {
        name: 'index-finger-skin-tone-1',
        categories: ['Smileys and emotions'],
        tags: [':index-finger:'],
        durationInSeconds: 1.9666666666666666,
        codepoint: '261d_1f3fb',
    },
    {
        name: 'index-finger-skin-tone-2',
        categories: ['Smileys and emotions'],
        tags: [':index-finger:'],
        durationInSeconds: 1.9666666666666666,
        codepoint: '261d_1f3fc',
    },
    {
        name: 'index-finger-skin-tone-3',
        categories: ['Smileys and emotions'],
        tags: [':index-finger:'],
        durationInSeconds: 1.9666666666666666,
        codepoint: '261d_1f3fd',
    },
    {
        name: 'index-finger-skin-tone-4',
        categories: ['Smileys and emotions'],
        tags: [':index-finger:'],
        durationInSeconds: 1.9666666666666666,
        codepoint: '261d_1f3fe',
    },
    {
        name: 'index-finger-skin-tone-5',
        categories: ['Smileys and emotions'],
        tags: [':index-finger:'],
        durationInSeconds: 1.9666666666666666,
        codepoint: '261d_1f3ff',
    },
    {
        name: 'folded-hands',
        categories: ['Smileys and emotions'],
        tags: [
            ':folded-hands:',
            ':please:',
            ':pray:',
            ':hope:',
            ':wish:',
            ':thank-you:',
            ':high-five:',
        ],
        durationInSeconds: 1.5,
        codepoint: '1f64f',
    },
    {
        name: 'folded-hands-skin-tone-1',
        categories: ['Smileys and emotions'],
        tags: [
            ':folded-hands:',
            ':please:',
            ':pray:',
            ':hope:',
            ':wish:',
            ':thank-you:',
            ':high-five:',
        ],
        durationInSeconds: 1.5,
        codepoint: '1f64f_1f3fb',
    },
    {
        name: 'folded-hands-skin-tone-2',
        categories: ['Smileys and emotions'],
        tags: [
            ':folded-hands:',
            ':please:',
            ':pray:',
            ':hope:',
            ':wish:',
            ':thank-you:',
            ':high-five:',
        ],
        durationInSeconds: 1.5,
        codepoint: '1f64f_1f3fc',
    },
    {
        name: 'folded-hands-skin-tone-3',
        categories: ['Smileys and emotions'],
        tags: [
            ':folded-hands:',
            ':please:',
            ':pray:',
            ':hope:',
            ':wish:',
            ':thank-you:',
            ':high-five:',
        ],
        durationInSeconds: 1.5,
        codepoint: '1f64f_1f3fd',
    },
    {
        name: 'folded-hands-skin-tone-4',
        categories: ['Smileys and emotions'],
        tags: [
            ':folded-hands:',
            ':please:',
            ':pray:',
            ':hope:',
            ':wish:',
            ':thank-you:',
            ':high-five:',
        ],
        durationInSeconds: 1.5,
        codepoint: '1f64f_1f3fe',
    },
    {
        name: 'folded-hands-skin-tone-5',
        categories: ['Smileys and emotions'],
        tags: [
            ':folded-hands:',
            ':please:',
            ':pray:',
            ':hope:',
            ':wish:',
            ':thank-you:',
            ':high-five:',
        ],
        durationInSeconds: 1.5,
        codepoint: '1f64f_1f3ff',
    },
    {
        name: 'dancer-woman',
        categories: ['People'],
        tags: [':dancer-woman:'],
        durationInSeconds: 1.6,
        codepoint: '1f483',
    },
    {
        name: 'dancer-woman-skin-tone-1',
        categories: ['People'],
        tags: [':dancer-woman:'],
        durationInSeconds: 1.6,
        codepoint: '1f483_1f3fb',
    },
    {
        name: 'dancer-woman-skin-tone-2',
        categories: ['People'],
        tags: [':dancer-woman:'],
        durationInSeconds: 1.6,
        codepoint: '1f483_1f3fc',
    },
    {
        name: 'dancer-woman-skin-tone-3',
        categories: ['People'],
        tags: [':dancer-woman:'],
        durationInSeconds: 1.6,
        codepoint: '1f483_1f3fd',
    },
    {
        name: 'dancer-woman-skin-tone-4',
        categories: ['People'],
        tags: [':dancer-woman:'],
        durationInSeconds: 1.6,
        codepoint: '1f483_1f3fe',
    },
    {
        name: 'dancer-woman-skin-tone-5',
        categories: ['People'],
        tags: [':dancer-woman:'],
        durationInSeconds: 1.6,
        codepoint: '1f483_1f3ff',
    },
    {
        name: 'rose',
        categories: ['Animals and nature'],
        tags: [':rose:'],
        durationInSeconds: 2.4,
        codepoint: '1f339',
    },
    {
        name: 'wilted-flower',
        categories: ['Animals and nature'],
        tags: [':wilted-flower:'],
        durationInSeconds: 2.4,
        codepoint: '1f940',
    },
    {
        name: 'fallen-leaf',
        categories: ['Animals and nature'],
        tags: [':fallen-leaf:'],
        durationInSeconds: 3.533333333333333,
        codepoint: '1f342',
    },
    {
        name: 'plant',
        categories: ['Animals and nature'],
        tags: [':plant:', ':seed:'],
        durationInSeconds: 5.75,
        codepoint: '1f331',
    },
    {
        name: 'leaves',
        categories: ['Animals and nature'],
        tags: [':leaves:'],
        durationInSeconds: 1.8,
        codepoint: '1f343',
    },
    {
        name: 'luck',
        categories: ['Animals and nature'],
        tags: [':luck:', ':four-leaf-clover:'],
        durationInSeconds: 1.8,
        codepoint: '1f340',
    },
    {
        name: 'snowflake',
        categories: ['Animals and nature'],
        tags: [':snowflake:', ':winter:', ':cold:'],
        durationInSeconds: 4.5,
        codepoint: '2744_fe0f',
    },
    {
        name: 'volcano',
        categories: ['Animals and nature'],
        tags: [':volcano:'],
        durationInSeconds: 1.2,
        codepoint: '1f30b',
    },
    {
        name: 'sunrise',
        categories: ['Animals and nature'],
        tags: [':sunrise:'],
        durationInSeconds: 5,
        codepoint: '1f305',
    },
    {
        name: 'sunrise-over-mountains',
        categories: ['Animals and nature'],
        tags: [':sunrise-over-mountains:'],
        durationInSeconds: 1.0166666666666666,
        codepoint: '1f304',
    },
    {
        name: 'rainbow',
        categories: ['Animals and nature'],
        tags: [':rainbow:'],
        durationInSeconds: 2,
        codepoint: '1f308',
    },
    {
        name: 'bubbles',
        categories: ['Animals and nature'],
        tags: [':bubbles:'],
        durationInSeconds: 2.3333333333333335,
        codepoint: '1fae7',
    },
    {
        name: 'ocean',
        categories: ['Animals and nature'],
        tags: [':ocean:'],
        durationInSeconds: 1.2333333333333334,
        codepoint: '1f30a',
    },
    {
        name: 'wind-face',
        categories: ['Animals and nature'],
        tags: [':wind-face:'],
        durationInSeconds: 1.6,
        codepoint: '1f32c_fe0f',
    },
    {
        name: 'tornado',
        categories: ['Animals and nature'],
        tags: [':tornado:'],
        durationInSeconds: 2,
        codepoint: '1f32a_fe0f',
    },
    {
        name: 'electricity',
        categories: ['Animals and nature'],
        tags: [':electricity:', ':zap:', ':lightning:'],
        durationInSeconds: 1.3833333333333333,
        codepoint: '26a1',
    },
    {
        name: 'droplet',
        categories: ['Animals and nature'],
        tags: [':droplet:'],
        durationInSeconds: 1.2,
        codepoint: '1f4a7',
    },
    {
        name: 'rain-cloud',
        categories: ['Animals and nature'],
        tags: [':rain-cloud:'],
        durationInSeconds: 3.2666666666666666,
        codepoint: '1f327_fe0f',
    },
    {
        name: 'cloud-with-lightning',
        categories: ['Animals and nature'],
        tags: [':cloud-with-lightning:'],
        durationInSeconds: 1.4,
        codepoint: '1f329_fe0f',
    },
    {
        name: 'dizzy',
        categories: ['Animals and nature'],
        tags: [':dizzy:'],
        durationInSeconds: 1.2,
        codepoint: '1f4ab',
    },
    {
        name: 'comet',
        categories: ['Animals and nature'],
        tags: [':comet:'],
        durationInSeconds: 1.65,
        codepoint: '2604_fe0f',
    },
    {
        name: 'globe-showing-europe-africa',
        categories: ['Animals and nature'],
        tags: [':globe-showing-Europe-Africa:'],
        durationInSeconds: 2.7,
        codepoint: '1f30d',
    },
    {
        name: 'globe-showing-americas',
        categories: ['Animals and nature'],
        tags: [':globe-showing-Americas:'],
        durationInSeconds: 2.7,
        codepoint: '1f30e',
    },
    {
        name: 'globe-showing-asia-australia',
        categories: ['Animals and nature'],
        tags: [':globe-showing-Asia-Australia:'],
        durationInSeconds: 2.7,
        codepoint: '1f30f',
    },
    {
        name: 'cow-face',
        categories: ['Animals and nature'],
        tags: [':cow-face:'],
        durationInSeconds: 1.7666666666666666,
        codepoint: '1f42e',
    },
    {
        name: 'unicorn',
        categories: ['Animals and nature'],
        tags: [':unicorn:'],
        durationInSeconds: 3.8,
        codepoint: '1f984',
    },
    {
        name: 'lizard',
        categories: ['Animals and nature'],
        tags: [':lizard:'],
        durationInSeconds: 1.7,
        codepoint: '1f98e',
    },
    {
        name: 'dragon',
        categories: ['Animals and nature'],
        tags: [':dragon:'],
        durationInSeconds: 2,
        codepoint: '1f409',
    },
    {
        name: 't-rex',
        categories: ['Animals and nature'],
        tags: [':t-rex:'],
        durationInSeconds: 1.55,
        codepoint: '1f996',
    },
    {
        name: 'dinosaur',
        categories: ['Animals and nature'],
        tags: [':dinosaur:'],
        durationInSeconds: 3.3666666666666667,
        codepoint: '1f995',
    },
    {
        name: 'turtle',
        categories: ['Animals and nature'],
        tags: [':turtle:'],
        durationInSeconds: 3.4,
        codepoint: '1f422',
    },
    {
        name: 'crocodile',
        categories: ['Animals and nature'],
        tags: [':crocodile:'],
        durationInSeconds: 2.933333333333333,
        codepoint: '1f40a',
    },
    {
        name: 'snake',
        categories: ['Animals and nature'],
        tags: [':snake:'],
        durationInSeconds: 3.2666666666666666,
        codepoint: '1f40d',
    },
    {
        name: 'frog',
        categories: ['Animals and nature'],
        tags: [':frog:'],
        durationInSeconds: 4.066666666666666,
        codepoint: '1f438',
    },
    {
        name: 'rabbit',
        categories: ['Animals and nature'],
        tags: [':rabbit:'],
        durationInSeconds: 1.3333333333333333,
        codepoint: '1f407',
    },
    {
        name: 'rat',
        categories: ['Animals and nature'],
        tags: [':rat:'],
        durationInSeconds: 2.6333333333333333,
        codepoint: '1f400',
    },
    {
        name: 'poodle',
        categories: ['Animals and nature'],
        tags: [':poodle:'],
        durationInSeconds: 2.8,
        codepoint: '1f429',
    },
    {
        name: 'dog',
        categories: ['Animals and nature'],
        tags: [':dog:'],
        durationInSeconds: 2.433333333333333,
        codepoint: '1f415',
    },
    {
        name: 'guide-dog',
        categories: ['Animals and nature'],
        tags: [':guide-dog:'],
        durationInSeconds: 2.1666666666666665,
        codepoint: '1f9ae',
    },
    {
        name: 'service-dog',
        categories: ['Animals and nature'],
        tags: [':service-dog:'],
        durationInSeconds: 3,
        codepoint: '1f415_200d_1f9ba',
    },
    {
        name: 'pig',
        categories: ['Animals and nature'],
        tags: [':pig:'],
        durationInSeconds: 3.566666666666667,
        codepoint: '1f416',
    },
    {
        name: 'racehorse',
        categories: ['Animals and nature'],
        tags: [':racehorse:'],
        durationInSeconds: 0.5166666666666667,
        codepoint: '1f40e',
    },
    {
        name: 'donkey',
        categories: ['Animals and nature'],
        tags: [':donkey:'],
        durationInSeconds: 2,
        codepoint: '1facf',
    },
    {
        name: 'ox',
        categories: ['Animals and nature'],
        tags: [':ox:'],
        durationInSeconds: 3.3,
        codepoint: '1f402',
    },
    {
        name: 'goat',
        categories: ['Animals and nature'],
        tags: [':goat:'],
        durationInSeconds: 2.066666666666667,
        codepoint: '1f410',
    },
    {
        name: 'kangaroo',
        categories: ['Animals and nature'],
        tags: [':kangaroo:'],
        durationInSeconds: 1.6,
        codepoint: '1f998',
    },
    {
        name: 'tiger',
        categories: ['Animals and nature'],
        tags: [':tiger:'],
        durationInSeconds: 5.1,
        codepoint: '1f405',
    },
    {
        name: 'monkey',
        categories: ['Animals and nature'],
        tags: [':monkey:'],
        durationInSeconds: 1.7666666666666666,
        codepoint: '1f412',
    },
    {
        name: 'gorilla',
        categories: ['Animals and nature'],
        tags: [':gorilla:'],
        durationInSeconds: 2.7333333333333334,
        codepoint: '1f98d',
    },
    {
        name: 'orangutan',
        categories: ['Animals and nature'],
        tags: [':orangutan:'],
        durationInSeconds: 3.8333333333333335,
        codepoint: '1f9a7',
    },
    {
        name: 'chipmunk',
        categories: ['Animals and nature'],
        tags: [':chipmunk:'],
        durationInSeconds: 3.066666666666667,
        codepoint: '1f43f_fe0f',
    },
    {
        name: 'otter',
        categories: ['Animals and nature'],
        tags: [':otter:'],
        durationInSeconds: 3,
        codepoint: '1f9a6',
    },
    {
        name: 'bat',
        categories: ['Animals and nature'],
        tags: [':bat:'],
        durationInSeconds: 1,
        codepoint: '1f987',
    },
    {
        name: 'bird',
        categories: ['Animals and nature'],
        tags: [':bird:'],
        durationInSeconds: 3.3666666666666667,
        codepoint: '1f426',
    },
    {
        name: 'black-bird',
        categories: ['Animals and nature'],
        tags: [':black-bird:'],
        durationInSeconds: 3.3666666666666667,
        codepoint: '1f426_200d_2b1b',
    },
    {
        name: 'rooster',
        categories: ['Animals and nature'],
        tags: [':rooster:'],
        durationInSeconds: 2.85,
        codepoint: '1f413',
    },
    {
        name: 'hatching-chick',
        categories: ['Animals and nature'],
        tags: [':hatching-chick:'],
        durationInSeconds: 3.466666666666667,
        codepoint: '1f423',
    },
    {
        name: 'baby-chick',
        categories: ['Animals and nature'],
        tags: [':baby-chick:'],
        durationInSeconds: 2.2,
        codepoint: '1f424',
    },
    {
        name: 'hatched-chick',
        categories: ['Animals and nature'],
        tags: [':hatched-chick:'],
        durationInSeconds: 2.966666666666667,
        codepoint: '1f425',
    },
    {
        name: 'eagle',
        categories: ['Animals and nature'],
        tags: [':eagle:'],
        durationInSeconds: 1.3333333333333333,
        codepoint: '1f985',
    },
    {
        name: 'peace',
        categories: ['Animals and nature'],
        tags: [':peace:', ':dove:'],
        durationInSeconds: 3.1666666666666665,
        codepoint: '1f54a_fe0f',
    },
    {
        name: 'goose',
        categories: ['Animals and nature'],
        tags: [':goose:'],
        durationInSeconds: 2.4,
        codepoint: '1fabf',
    },
    {
        name: 'peacock',
        categories: ['Animals and nature'],
        tags: [':peacock:'],
        durationInSeconds: 1.3333333333333333,
        codepoint: '1f99a',
    },
    {
        name: 'seal',
        categories: ['Animals and nature'],
        tags: [':seal:'],
        durationInSeconds: 2.566666666666667,
        codepoint: '1f9ad',
    },
    {
        name: 'shark',
        categories: ['Animals and nature'],
        tags: [':shark:'],
        durationInSeconds: 3.2,
        codepoint: '1f988',
    },
    {
        name: 'dolphin',
        categories: ['Animals and nature'],
        tags: [':dolphin:'],
        durationInSeconds: 1.8333333333333333,
        codepoint: '1f42c',
    },
    {
        name: 'whale',
        categories: ['Animals and nature'],
        tags: [':whale:'],
        durationInSeconds: 2.6333333333333333,
        codepoint: '1f433',
    },
    {
        name: 'blowfish',
        categories: ['Animals and nature'],
        tags: [':blowfish:'],
        durationInSeconds: 2.8,
        codepoint: '1f421',
    },
    {
        name: 'crab',
        categories: ['Animals and nature'],
        tags: [':crab:'],
        durationInSeconds: 2.3,
        codepoint: '1f980',
    },
    {
        name: 'octopus',
        categories: ['Animals and nature'],
        tags: [':octopus:'],
        durationInSeconds: 1.6,
        codepoint: '1f419',
    },
    {
        name: 'jellyfish',
        categories: ['Animals and nature'],
        tags: [':jellyfish:'],
        durationInSeconds: 2.533333333333333,
        codepoint: '1fabc',
    },
    {
        name: 'spider',
        categories: ['Animals and nature'],
        tags: [':spider:'],
        durationInSeconds: 2.4,
        codepoint: '1f577_fe0f',
    },
    {
        name: 'snail',
        categories: ['Animals and nature'],
        tags: [':snail:'],
        durationInSeconds: 2.7,
        codepoint: '1f40c',
    },
    {
        name: 'ant',
        categories: ['Animals and nature'],
        tags: [':ant:'],
        durationInSeconds: 4.033333333333333,
        codepoint: '1f41c',
    },
    {
        name: 'mosquito',
        categories: ['Animals and nature'],
        tags: [':mosquito:'],
        durationInSeconds: 1.8,
        codepoint: '1f99f',
    },
    {
        name: 'cockroach',
        categories: ['Animals and nature'],
        tags: [':cockroach:'],
        durationInSeconds: 2.2,
        codepoint: '1fab3',
    },
    {
        name: 'fly',
        categories: ['Animals and nature'],
        tags: [':fly:'],
        durationInSeconds: 2.4,
        codepoint: '1fab0',
    },
    {
        name: 'bee',
        categories: ['Animals and nature'],
        tags: [':bee:'],
        durationInSeconds: 5.5,
        codepoint: '1f41d',
    },
    {
        name: 'lady-bug',
        categories: ['Animals and nature'],
        tags: [':lady-bug:'],
        durationInSeconds: 5.9,
        codepoint: '1f41e',
    },
    {
        name: 'butterfly',
        categories: ['Animals and nature'],
        tags: [':butterfly:'],
        durationInSeconds: 2.8,
        codepoint: '1f98b',
    },
    {
        name: 'bug',
        categories: ['Animals and nature'],
        tags: [':bug:'],
        durationInSeconds: 3.933333333333333,
        codepoint: '1f41b',
    },
    {
        name: 'worm',
        categories: ['Animals and nature'],
        tags: [':worm:'],
        durationInSeconds: 4.266666666666667,
        codepoint: '1fab1',
    },
    {
        name: 'paw-prints',
        categories: ['Animals and nature'],
        tags: [':paw prints:'],
        durationInSeconds: 1.1,
        codepoint: '1f43e',
    },
    {
        name: 'tomato',
        categories: ['Food and drink'],
        tags: [':tomato:'],
        durationInSeconds: 2.7666666666666666,
        codepoint: '1f345',
    },
    {
        name: 'cooking',
        categories: ['Food and drink'],
        tags: [':cooking:'],
        durationInSeconds: 2.2,
        codepoint: '1f373',
    },
    {
        name: 'spaghetti',
        categories: ['Food and drink'],
        tags: [':spaghetti:'],
        durationInSeconds: 2.05,
        codepoint: '1f35d',
    },
    {
        name: 'steaming-bowl',
        categories: ['Food and drink'],
        tags: [':steaming-bowl:'],
        durationInSeconds: 1.8,
        codepoint: '1f35c',
    },
    {
        name: 'popcorn',
        categories: ['Food and drink'],
        tags: [':popcorn:'],
        durationInSeconds: 2.8666666666666667,
        codepoint: '1f37f',
    },
    {
        name: 'hot-beverage',
        categories: ['Food and drink'],
        tags: [':hot-beverage:'],
        durationInSeconds: 2.0166666666666666,
        codepoint: '2615',
    },
    {
        name: 'clinking-beer-mugs',
        categories: ['Food and drink'],
        tags: [':clinking-beer-mugs:'],
        durationInSeconds: 1.7666666666666666,
        codepoint: '1f37b',
    },
    {
        name: 'clinking-glasses',
        categories: ['Food and drink'],
        tags: [':clinking-glasses:'],
        durationInSeconds: 2.3333333333333335,
        codepoint: '1f942',
    },
    {
        name: 'bottle-with-popping-cork',
        categories: ['Food and drink'],
        tags: [':bottle-with-popping-cork:'],
        durationInSeconds: 2.5,
        codepoint: '1f37e',
    },
    {
        name: 'wine-glass',
        categories: ['Food and drink'],
        tags: [':wine-glass:'],
        durationInSeconds: 1.8,
        codepoint: '1f377',
    },
    {
        name: 'tropical-drink',
        categories: ['Food and drink'],
        tags: [':tropical-drink:'],
        durationInSeconds: 3.6,
        codepoint: '1f379',
    },
    {
        name: 'construction',
        categories: ['Travel and places'],
        tags: [':construction:'],
        durationInSeconds: 2.4,
        codepoint: '1f6a7',
    },
    {
        name: 'police-car-light',
        categories: ['Travel and places'],
        tags: [':police-car-light:'],
        durationInSeconds: 1.6666666666666667,
        codepoint: '1f6a8',
    },
    {
        name: 'bicycle',
        categories: ['Travel and places'],
        tags: [':bicycle:'],
        durationInSeconds: 3,
        codepoint: '1f6b2',
    },
    {
        name: 'flying-saucer',
        categories: ['Travel and places'],
        tags: [':flying-saucer:'],
        durationInSeconds: 4.633333333333334,
        codepoint: '1f6f8',
    },
    {
        name: 'rocket',
        categories: ['Travel and places'],
        tags: [':rocket:'],
        durationInSeconds: 0.6666666666666666,
        codepoint: '1f680',
    },
    {
        name: 'airplane-departure',
        categories: ['Travel and places'],
        tags: [':airplane-departure:'],
        durationInSeconds: 2.1,
        codepoint: '1f6eb',
    },
    {
        name: 'airplane-arrival',
        categories: ['Travel and places'],
        tags: [':airplane-arrival:'],
        durationInSeconds: 1.9333333333333333,
        codepoint: '1f6ec',
    },
    {
        name: 'roller-coaster',
        categories: ['Travel and places'],
        tags: [':roller-coaster:'],
        durationInSeconds: 2.1666666666666665,
        codepoint: '1f3a2',
    },
    {
        name: 'camping',
        categories: ['Travel and places'],
        tags: [':camping:'],
        durationInSeconds: 2.716666666666667,
        codepoint: '1f3d5_fe0f',
    },
    {
        name: 'confetti-ball',
        categories: ['Activities and events'],
        tags: [':confetti-ball:'],
        durationInSeconds: 2.4,
        codepoint: '1f38a',
    },
    {
        name: 'balloon',
        categories: ['Activities and events'],
        tags: [':balloon:'],
        durationInSeconds: 1.6,
        codepoint: '1f388',
    },
    {
        name: 'birthday-cake',
        categories: ['Activities and events'],
        tags: [':birthday-cake:'],
        durationInSeconds: 2.6333333333333333,
        codepoint: '1f382',
    },
    {
        name: 'wrapped-gift',
        categories: ['Activities and events'],
        tags: [':wrapped-gift:'],
        durationInSeconds: 2.4,
        codepoint: '1f381',
    },
    {
        name: 'fireworks',
        categories: ['Activities and events'],
        tags: [':fireworks:'],
        durationInSeconds: 2.066666666666667,
        codepoint: '1f386',
    },
    {
        name: 'pinata',
        categories: ['Activities and events'],
        tags: [':piñata:'],
        durationInSeconds: 2.966666666666667,
        codepoint: '1fa85',
    },
    {
        name: 'mirror-ball',
        categories: ['Activities and events'],
        tags: [':mirror-ball:', ':disco-ball:'],
        durationInSeconds: 1.8,
        codepoint: '1faa9',
    },
    {
        name: 'soccer-ball',
        categories: ['Activities and events'],
        tags: [':soccer-ball:'],
        durationInSeconds: 2,
        codepoint: '26bd',
    },
    {
        name: 'baseball',
        categories: ['Activities and events'],
        tags: [':baseball:'],
        durationInSeconds: 2.3333333333333335,
        codepoint: '26be',
    },
    {
        name: 'softball',
        categories: ['Activities and events'],
        tags: [':softball:'],
        durationInSeconds: 2.3333333333333335,
        codepoint: '1f94e',
    },
    {
        name: 'tennis',
        categories: ['Activities and events'],
        tags: [':tennis:'],
        durationInSeconds: 1.4,
        codepoint: '1f3be',
    },
    {
        name: 'badminton',
        categories: ['Activities and events'],
        tags: [':badminton:'],
        durationInSeconds: 1.4,
        codepoint: '1f3f8',
    },
    {
        name: 'lacrosse',
        categories: ['Activities and events'],
        tags: [':lacrosse:'],
        durationInSeconds: 2.6,
        codepoint: '1f94d',
    },
    {
        name: 'cricket-game',
        categories: ['Activities and events'],
        tags: [':cricket-game:'],
        durationInSeconds: 1.4,
        codepoint: '1f3cf',
    },
    {
        name: 'field-hockey',
        categories: ['Activities and events'],
        tags: [':field-hockey:'],
        durationInSeconds: 2.1333333333333333,
        codepoint: '1f3d1',
    },
    {
        name: 'ice-hockey',
        categories: ['Activities and events'],
        tags: [':ice-hockey:'],
        durationInSeconds: 1.6,
        codepoint: '1f3d2',
    },
    {
        name: 'direct-hit',
        categories: ['Activities and events'],
        tags: [':direct-hit:', ':target:'],
        durationInSeconds: 2.3333333333333335,
        codepoint: '1f3af',
    },
    {
        name: 'flying-disc',
        categories: ['Activities and events'],
        tags: [':flying-disc:'],
        durationInSeconds: 0.8,
        codepoint: '1f94f',
    },
    {
        name: 'boomerang',
        categories: ['Activities and events'],
        tags: [':boomerang:'],
        durationInSeconds: 1.4666666666666666,
        codepoint: '1fa83',
    },
    {
        name: 'kite',
        categories: ['Activities and events'],
        tags: [':kite:'],
        durationInSeconds: 1.6,
        codepoint: '1fa81',
    },
    {
        name: 'ping-pong',
        categories: ['Activities and events'],
        tags: [':ping-pong:'],
        durationInSeconds: 1.5666666666666667,
        codepoint: '1f3d3',
    },
    {
        name: 'bowling',
        categories: ['Activities and events'],
        tags: [':bowling:'],
        durationInSeconds: 1.55,
        codepoint: '1f3b3',
    },
    {
        name: 'die',
        categories: ['Activities and events'],
        tags: [':die:'],
        durationInSeconds: 2.033333333333333,
        codepoint: '1f3b2',
    },
    {
        name: 'slot-machine',
        categories: ['Activities and events'],
        tags: [':slot-machine:'],
        durationInSeconds: 2,
        codepoint: '1f3b0',
    },
    {
        name: 'camera-flash',
        categories: ['Activities and events'],
        tags: [':camera-flash:'],
        durationInSeconds: 1.2,
        codepoint: '1f4f8',
    },
    {
        name: 'violin',
        categories: ['Activities and events'],
        tags: [':violin:'],
        durationInSeconds: 7,
        codepoint: '1f3bb',
    },
    {
        name: 'drum',
        categories: ['Activities and events'],
        tags: [':drum:'],
        durationInSeconds: 2.7,
        codepoint: '1f941',
    },
    {
        name: 'maracas',
        categories: ['Activities and events'],
        tags: [':maracas:'],
        durationInSeconds: 1.5333333333333334,
        codepoint: '1fa87',
    },
    {
        name: 'battery-full',
        categories: ['Objects'],
        tags: [':battery-full:'],
        durationInSeconds: 1.7333333333333334,
        codepoint: '1f50b',
    },
    {
        name: 'battery-low',
        categories: ['Objects'],
        tags: [':battery-low:'],
        durationInSeconds: 6.3,
        codepoint: '1faab',
    },
    {
        name: 'money-with-wings',
        categories: ['Objects'],
        tags: [':money-with-wings:'],
        durationInSeconds: 0.8,
        codepoint: '1f4b8',
    },
    {
        name: 'balance-scale',
        categories: ['Objects'],
        tags: [':balance-scale:'],
        durationInSeconds: 4.366666666666666,
        codepoint: '2696_fe0f',
    },
    {
        name: 'light-bulb',
        categories: ['Objects'],
        tags: [':light-bulb:'],
        durationInSeconds: 2.4,
        codepoint: '1f4a1',
    },
    {
        name: 'graduation-cap',
        categories: ['Objects'],
        tags: [':graduation-cap:'],
        durationInSeconds: 1.4,
        codepoint: '1f393',
    },
    {
        name: 'umbrella',
        categories: ['Objects'],
        tags: [':umbrella:'],
        durationInSeconds: 3.3333333333333335,
        codepoint: '2602_fe0f',
    },
    {
        name: 'gem-stone',
        categories: ['Objects'],
        tags: [':gem-stone:'],
        durationInSeconds: 1.3333333333333333,
        codepoint: '1f48e',
    },
    {
        name: 'gear',
        categories: ['Objects'],
        tags: [':gear:'],
        durationInSeconds: 5,
        codepoint: '2699_fe0f',
    },
    {
        name: 'pencil',
        categories: ['Objects'],
        tags: [':pencil:'],
        durationInSeconds: 2.1,
        codepoint: '270f_fe0f',
    },
    {
        name: 'alarm-clock',
        categories: ['Objects'],
        tags: [':alarm-clock:'],
        durationInSeconds: 0.5666666666666667,
        codepoint: '23f0',
    },
    {
        name: 'bellhop-bell',
        categories: ['Objects'],
        tags: [':bellhop-bell:'],
        durationInSeconds: 1.3333333333333333,
        codepoint: '1f6ce_fe0f',
    },
    {
        name: 'bell',
        categories: ['Objects'],
        tags: [':bell:'],
        durationInSeconds: 0.8,
        codepoint: '1f514',
    },
    {
        name: 'crystal-ball',
        categories: ['Objects'],
        tags: [':crystal-ball:'],
        durationInSeconds: 2.4,
        codepoint: '1f52e',
    },
    {
        name: 'aries',
        categories: ['Symbols'],
        tags: [':Aries:'],
        durationInSeconds: 5.7,
        codepoint: '2648',
    },
    {
        name: 'taurus',
        categories: ['Symbols'],
        tags: [':Taurus:'],
        durationInSeconds: 5.7,
        codepoint: '2649',
    },
    {
        name: 'gemini',
        categories: ['Symbols'],
        tags: [':Gemini:'],
        durationInSeconds: 5.7,
        codepoint: '264a',
    },
    {
        name: 'cancer',
        categories: ['Symbols'],
        tags: [':Cancer:'],
        durationInSeconds: 5.7,
        codepoint: '264b',
    },
    {
        name: 'leo',
        categories: ['Symbols'],
        tags: [':Leo:'],
        durationInSeconds: 5.7,
        codepoint: '264c',
    },
    {
        name: 'virgo',
        categories: ['Symbols'],
        tags: [':Virgo:'],
        durationInSeconds: 5.7,
        codepoint: '264d',
    },
    {
        name: 'libra',
        categories: ['Symbols'],
        tags: [':Libra:'],
        durationInSeconds: 5.7,
        codepoint: '264e',
    },
    {
        name: 'scorpio',
        categories: ['Symbols'],
        tags: [':Scorpio:'],
        durationInSeconds: 5.7,
        codepoint: '264f',
    },
    {
        name: 'sagittarius',
        categories: ['Symbols'],
        tags: [':Sagittarius:'],
        durationInSeconds: 5.7,
        codepoint: '2650',
    },
    {
        name: 'capricorn',
        categories: ['Symbols'],
        tags: [':Capricorn:'],
        durationInSeconds: 6.4,
        codepoint: '2651',
    },
    {
        name: 'aquarius',
        categories: ['Symbols'],
        tags: [':Aquarius:'],
        durationInSeconds: 5.7,
        codepoint: '2652',
    },
    {
        name: 'pisces',
        categories: ['Symbols'],
        tags: [':Pisces:'],
        durationInSeconds: 5.7,
        codepoint: '2653',
    },
    {
        name: 'ophiuchus',
        categories: ['Symbols'],
        tags: [':Ophiuchus:'],
        durationInSeconds: 5.7,
        codepoint: '26ce',
    },
    {
        name: 'exclamation',
        categories: ['Symbols'],
        tags: [':exclamation:', ':exclamation-mark:'],
        durationInSeconds: 3.3333333333333335,
        codepoint: '2757',
    },
    {
        name: 'question',
        categories: ['Symbols'],
        tags: [':question:', ':question-mark:', ':?:'],
        durationInSeconds: 3.3333333333333335,
        codepoint: '2753',
    },
    {
        name: 'exclamation-question-mark',
        categories: ['Symbols'],
        tags: [':exclamation-question-mark:', ':!?:'],
        durationInSeconds: 3.3333333333333335,
        codepoint: '2049_fe0f',
    },
    {
        name: 'exclamation-double',
        categories: ['Symbols'],
        tags: [':exclamation-double:', ':!!:'],
        durationInSeconds: 3.3333333333333335,
        codepoint: '203c_fe0f',
    },
    {
        name: 'cross-mark',
        categories: ['Symbols'],
        tags: [':cross-mark:', ':x:'],
        durationInSeconds: 1.9666666666666666,
        codepoint: '274c',
    },
    {
        name: 'sos',
        categories: ['Symbols'],
        tags: [':sos:'],
        durationInSeconds: 1.6666666666666667,
        codepoint: '1f198',
    },
    {
        name: 'phone-off',
        categories: ['Symbols'],
        tags: [':phone-off:'],
        durationInSeconds: 1.6666666666666667,
        codepoint: '1f4f4',
    },
    {
        name: 'check-mark',
        categories: ['Symbols'],
        tags: [':check-mark:', ':check-mark-green:'],
        durationInSeconds: 1.6666666666666667,
        codepoint: '2705',
    },
    {
        name: 'new',
        categories: ['Symbols'],
        tags: [':new:'],
        durationInSeconds: 1.6666666666666667,
        codepoint: '1f195',
    },
    {
        name: 'free',
        categories: ['Symbols'],
        tags: [':free:'],
        durationInSeconds: 1.6666666666666667,
        codepoint: '1f193',
    },
    {
        name: 'up',
        categories: ['Symbols'],
        tags: [':up!:'],
        durationInSeconds: 1.6666666666666667,
        codepoint: '1f199',
    },
    {
        name: 'cool',
        categories: ['Symbols'],
        tags: [':cool:'],
        durationInSeconds: 1.6666666666666667,
        codepoint: '1f192',
    },
    {
        name: 'litter',
        categories: ['Symbols'],
        tags: [':litter:'],
        durationInSeconds: 1.4166666666666667,
        codepoint: '1f6ae',
    },
    {
        name: 'musical-notes',
        categories: ['Symbols'],
        tags: [':musical-notes:'],
        durationInSeconds: 1,
        codepoint: '1f3b6',
    },
    {
        name: 'plus-sign',
        categories: ['Symbols'],
        tags: [':plus-sign:', ':+:'],
        durationInSeconds: 2.8,
        codepoint: '2795',
    },
    {
        name: 'chequered-flag',
        categories: ['Flags'],
        tags: [':chequered-flag:'],
        durationInSeconds: 4,
        codepoint: '1f3c1',
    },
    {
        name: 'triangular-flag',
        categories: ['Flags'],
        tags: [':triangular-flag:'],
        durationInSeconds: 3.966666666666667,
        codepoint: '1f6a9',
    },
    {
        name: 'black-flag',
        categories: ['Flags'],
        tags: [':black-flag:'],
        durationInSeconds: 4,
        codepoint: '1f3f4',
    },
    {
        name: 'white-flag',
        categories: ['Flags'],
        tags: [':white-flag:'],
        durationInSeconds: 4,
        codepoint: '1f3f3_fe0f',
    },
];
